var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Pill,{attrs:{"type":_vm.highlighted ? 'filter' : 'similarity',"on-change":_setup.onChange,"tooltip":_setup.tooltip,"is-inverted-color":_vm.isInvertedColor,"size":_vm.size}},[_vm._v(" "+_vm._s(_setup.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }